import React, { useMemo } from "react";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import styles from "./Table.module.scss";
import ArrowIcon from "../SVGComponents/ArrowIcon";
import { combineClasses } from "@/lib/utils";
import { PAGINATION } from "@/lib/constants";

interface PaginationProps {
  isPagination: boolean;
  totalCount: number; // total number of rows
  pageSelected: number; // current page (1-based)
  setPageSelected: (page: number) => void; // called when page changes
  rowsPerPageValue: number; // current rows per page
  setRowsPerPageValue: (rows: number) => void; // called when rows per page changes
  rowsPerPageOptions?: number[];
  loading?: boolean;
  customRowsPerPage?: boolean;
}

const Pagination: React.FC<PaginationProps> = ({
  isPagination,
  totalCount,
  pageSelected,
  setPageSelected,
  rowsPerPageValue,
  setRowsPerPageValue,
  rowsPerPageOptions = [5, 10, 25, 50],
  customRowsPerPage = true,
}) => {
  if (!isPagination || totalCount === 0) return null;

  const noOfPages = Math.max(1, Math.ceil(totalCount / rowsPerPageValue));

  const handlePageClick = (e: { selected: number }) => {
    setPageSelected(e.selected + 1); // ReactPaginate is 0-based
  };

  const startIndex = (pageSelected - 1) * rowsPerPageValue + 1;
  const endIndex = Math.min(pageSelected * rowsPerPageValue, totalCount);
  // Starting and ending indices for display (optional)
  // const startingData = useMemo(() => {
  //   return totalCount === 0 ? 0 : (pageSelected - 1) * rowsPerPageValue + 1;
  // }, [pageSelected, rowsPerPageValue, totalCount]);

  // const endingData = useMemo(() => {
  //   return Math.min(pageSelected * rowsPerPageValue, totalCount);
  // }, [pageSelected, rowsPerPageValue, totalCount]);

  // Only update page if different
  // const handlePageClick = (e: { selected: number }) => {
  //   setPageSelected(e.selected + 1); // ReactPaginate is 0-based
  // };

  // No need for pagination if only 1 page

  return (
    <div className="flex items-center mt-4 gap-2 w-full">

      <div className="flex-1 flex justify-center">
        <ReactPaginate
          breakLabel="..."
          previousLabel="<"
          nextLabel=">"
          pageCount={noOfPages}
          onPageChange={handlePageClick}
          forcePage={pageSelected - 1}
          containerClassName="flex gap-2 list-none"
          pageClassName="w-8 h-8 flex justify-center items-center border rounded cursor-pointer"
          activeClassName="bg-indigo-50 border-indigo-500 text-indigo-700 font-semibold"
          previousClassName="w-8 h-8 flex justify-center items-center border rounded cursor-pointer"
          nextClassName="w-8 h-8 flex justify-center items-center border rounded cursor-pointer"
          disabledClassName="opacity-50 cursor-not-allowed"
          pageLinkClassName="w-full h-full flex justify-center items-center"
          previousLinkClassName="w-full h-full flex justify-center items-center"
          nextLinkClassName="w-full h-full flex justify-center items-center"
        />
      </div>

      <div className="ml-auto text-sm text-gray-600 font-medium whitespace-nowrap">
        {`${startIndex} – ${endIndex} of ${totalCount}`}
      </div>

    </div>

  );
};

export default Pagination;
